import PropTypes from 'prop-types'
import React, { Component, useEffect } from "react"
import { connect } from "react-redux"
import { withRouter } from "react-router-dom"
import { logoutUser } from "../../store/actions"
import SweetAlert from "react-bootstrap-sweetalert"
import { Card, Row, Col, CardBody, CardTitle, Container } from "reactstrap"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import ApiRest from "../../ayudas/apiRest"
import { apiError, loginUser, socialLogin } from "../../store/actions"

const Logout = props => {
    useEffect(() => {
        props.logoutUser(props.history)
    })
}

Logout.propTypes = {
    history: PropTypes.object,
    logoutUser: PropTypes.func,
    loginUser: PropTypes.func,
}

class Timeout extends Component {
    constructor(props) {
        super(props);
        this.apiRest = new ApiRest(props);
        this.state = { 
            timeralert: null, 
            timerswitch: false, 
            seconds: 0 
        }
        this.tick = this.tick.bind(this)
    }
    tick() {
        this.interval = setInterval(() => {
            this.setState(prevState => ({ seconds: prevState.seconds + 1 }))
        }, 1000)
    }

    componentDidMount() {
        this.hideAlert()
    }

    hideAlert() {
        this.salida();
        this.apiRest.setLS('authUser',null);
        this.apiRest.setLS('du',null);
        this.props.history.push("/login")
    }

    salida =()=>{
        let aux = this.apiRest.getLS('authUser')
        this.apiRest.postSinToken('/logout/blacklist/',{refresh_token: aux.refresh}).then(resultado => {
            if (resultado.exitoso) {
               console.log(resultado)
            }
        }).catch(error => {
            console.error('Error:', error);
        });
    }

    confirmAlert(props) {
        this.setState({ timeralert: null })
        
        let aux = this.apiRest.getLS('authUser')
        this.apiRest.postSinToken('/token/refresh/',{refresh: aux.refresh}).then(resultado => {
            if (resultado.exitoso) {
                this.apiRest.setLS("authUser", resultado.data);
                props.history.push("/dashboard");
            } else {
                this.hideAlert();
            }
        }).catch(error => {
            console.error('Error:', error);
            this.hideAlert();
        });
    }
    main_function() {
        setTimeout(
            function () {
                setTimeout(
                    function () {
                        this.function1()
                    }.bind(this),
                    10000
                )
                this.function2()
            }.bind(this),
            1000
        )
    }
    function1() {
        if (window.location.pathname === "/Timeout") {
            this.hideAlert();
        }
    }
    function2() {
        this.tick()
        const nextmsg = () => (
            <SweetAlert
                showCancel
                confirmBtnText="Mantente conectado"
                cancelBtnText="Logout"
                confirmBtnBsStyle="success"
                cancelBtnBsStyle="danger"
                title="¡Su sesión a expirado!"
                onCancel={() => this.hideAlert()}
                onConfirm={() => this.confirmAlert(this.props)}
            >
                Redirecting in 10s seconds.<br></br>
            </SweetAlert>
        )
        this.setState({ timeralert: nextmsg() })
    }

    User() {

    }

    render() {
        return (
            <React.Fragment>
                <div className="page-content">
                    <Container fluid={true}>
                        {this.state.timeralert}

                        <Breadcrumbs title="Exit" breadcrumbItem="Session Timeout" />

                        <Row>
                            <Col>
                                <Card>
                                    <CardBody>
                                        <CardTitle>Session-timeout</CardTitle>
                                        <div>
                                        </div>
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                    </Container>
                </div>
            </React.Fragment>
        )
    }
}

export default withRouter(connect(null, { logoutUser })(Timeout))